import { Alert } from 'antd';
import * as React from 'react';
export default class LoginWarning extends React.Component<any, any> {

  constructor(props: any) {
    super(props);
  }

  render() {

    let message;
    switch (this.props.messageType) {
      case 'relogin':
        message = <span>Token expired. Please <a href='https://www.nswlrs.com.au/' target='_blank'>re-login</a> to view restricted collections.</span>;
        break;
      case 'tokenError':
        message = <span>Invalid Token. Please <a href='https://www.nswlrs.com.au/' target='_blank'>re-login</a> to view restricted collections.</span>;
        break;
    }



    return (
      <div style={{display: "inline", padding: "5px 0 0  0", float: "right" }}>
        {this.props.messageType != 'valid' && (
          <Alert type="error" showIcon={true} message={message} />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LoginWarning.tsx